(ns dre.app.countries
  (:require [dre.coll :refer [map-by]]))

(def code->ihme
  {"MTQ" nil ;;"Martinique",
   "GUY" 113,
   "TGO" 218,
   "VCT" 117,
   "MAF" nil ;;"Saint Martin (French part)",
   "BFA" 201,
   "ARM" 33,
   "IDN" 11,
   "MWI" 182,
   "AUT" 75,
   "BGD" 161,
   "MDV" 14,
   "WSM" 27,
   "MAR" 148,
   "SRB" 53,
   "TKL" 413,
   "IRN" 142,
   "SYR" 153,
   "JOR" 144,
   "MOZ" 184,
   "UGA" 190,
   "COG" 170,
   "SGS" nil ;;"South Georgia and the South Sandwich Islands",
   "POL" 51,
   "OMN" 150,
   "MRT" 212,
   "BMU" 305,
   "BEL" 76,
   "SYC" 186,
   "CCK" nil ;;"Cocos (Keeling) Islands",
   "GBR" 95,
   "SPM" nil ;;"Saint Pierre and Miquelon",
   "DOM" 111,
   "MNG" 38,
   "CYP" 77,
   "SVN" 55,
   "LCA" 116,
   "SLE" 217,
   "YEM" 157,
   "MHL" 24,
   "SWE" 93,
   "ARE" 156,
   "EGY" 141,
   "ZAF" 196,
   "FIN" 79,
   "IRQ" 143,
   "GLP" nil ;;"Guadeloupe",
   "CZE" 47,
   "TKM" 40,
   "TCA" nil ;;"Turks and Caicos Islands",
   "MCO" 367,
   "BLR" 57,
   "CYM" nil ;;"Cayman Islands",
   "NIU" 374,
   "CPV" 203,
   "FRO" nil ;;"Faroe Islands",
   "GGY" nil ;;"Guernsey",
   "MAC" 361,
   "CHN" 6,
   "LTU" 60,
   "BVT" nil ;;"Bouvet Island",
   "TWN" 8,
   "CRI" 126,
   "VNM" 20,
   "WLF" nil ;;"Wallis and Futuna",
   "HTI" 114,
   "LKA" 17,
   "ARG" 97,
   "LVA" 59,
   "DJI" 177,
   "PYF" nil ;;"French Polynesia",
   "ZWE" 198,
   "NFK" 44723,
   "LBY" 147,
   "SAU" 152,
   "VGB" nil ;;"Virgin Islands, British",
   "GMB" 206,
   "TUV" 416,
   "BEN" 200,
   "GTM" 128,
   "ROU" 52,
   "ESH" nil ;;"Western Sahara",
   "KGZ" 37,
   "DEU" 81,
   "FJI" 22,
   "MKD" 49,
   "HRV" 46,
   "HUN" 48,
   "SHN" 44665,
   "SMR" 396,
   "IND" 163,
   "GNQ" 172,
   "NPL" 164,
   "PRI" 385,
   "AFG" 160,
   "PNG" 26,
   "ATF" nil ;;"French Southern Territories",
   "ZMB" 191,
   "REU" nil ;;"Réunion",
   "PRT" 91,
   "GUF" nil ;;"French Guiana",
   "UKR" 63,
   "MSR" nil ;;"Montserrat",
   "SUR" 118,
   "BGR" 45,
   "TUN" 154,
   "GHA" 207,
   "MDA" 61,
   "AGO" 168,
   "MLT" 88,
   "CAN" 101,
   "PAK" 165,
   "VUT" 30,
   "KHM" 10,
   "ERI" 178,
   "MNE" 50,
   "FRA" 80,
   "CMR" 202,
   "SXM" nil ;;"Sint Maarten (Dutch part)",
   "SDN" 522,
   "CUB" 109,
   "THA" 18,
   "URY" 99,
   "COK" 320,
   "IOT" nil ;;"British Indian Ocean Territory",
   "AZE" 34,
   "VAT" nil ;;"Holy See (Vatican City State)",
   "CUW" nil ;;"Curaçao",
   "TCD" 204,
   "COM" 176,
   "BLM" nil ;;"Saint Barthélemy",
   "BWA" 193,
   "NRU" 369,
   "BHS" 106,
   "AND" 74,
   "GIB" nil ;;"Gibraltar",
   "BRB" 107,
   "TJK" 39,
   "BDI" 175,
   "IMN" nil ;;"Isle of Man",
   "PSE" 149,
   "EST" 58,
   "BTN" 162,
   "KIR" 23,
   "KOR" 68,
   "SLB" 28,
   "KAZ" 36,
   "ABW" nil ;;"Aruba",
   "JEY" nil ;;"Jersey",
   "SWZ" 197,
   "ITA" 86,
   "NAM" 195,
   "PHL" 16,
   "RUS" 62,
   "MMR" 15,
   "VIR" 422,
   "KNA" 393,
   "NLD" 89,
   "LSO" 194,
   "HND" 129,
   "MEX" 130,
   "CAF" 169,
   "ALA" nil ;;"Åland Islands",
   "ETH" 179,
   "DNK" 78,
   "KWT" 145,
   "DMA" 110,
   "ECU" 122,
   "RWA" 185,
   "SJM" nil ;;"Svalbard and Jan Mayen",
   "ATG" 105,
   "TLS" 19,
   "NER" 25344,
   "GRC" 82,
   "SOM" 187,
   "TON" 29,
   "GNB" 209,
   "GRD" 112,
   "GEO" 533,
   "SLV" 127,
   "LUX" 87,
   "NCL" nil ;;"New Caledonia",
   "ISL" 83,
   "QAT" 151,
   "BRA" 135,
   "BIH" 44,
   "NZL" 72,
   "JPN" 67,
   "PER" 123,
   "LBN" 146,
   "BHR" 140,
   "ATA" nil ;;"Antarctica",
   "TUR" 155,
   "VEN" 133,
   "TTO" 119,
   "STP" 215,
   "ESP" 92,
   "AIA" nil ;;"Anguilla",
   "SGP" 69,
   "SEN" 216,
   "HMD" nil ;;"Heard Island and McDonald Islands",
   "MDG" 181,
   "ISR" 85,
   "BES" nil ;;"Bonaire, Sint Eustatius and Saba",
   "ASM" 298,
   "USA" 102,
   "PLW" 380,
   "ALB" 43,
   "LBR" 210,
   "BOL" 121,
   "SSD" 435,
   "BRN" 66,
   "CHL" 98,
   "FSM" 25,
   "PAN" 132,
   "FLK" nil ;;"Falkland Islands (Malvinas)",
   "COD" 171,
   "MNP" 376,
   "IRL" 84,
   "CIV" 205,
   "MLI" 211,
   "MYS" 13,
   "MYT" nil, ;;"Mayotte",
   "kosovo" nil ;;"Kosovo",
   "PCN" nil ;;"Pitcairn",
   "UMI" nil ;;"United States Minor Outlying Islands",
   "CXR" nil ;;"Christmas Island",
   "AUS" 71,
   "BLZ" 108,
   "UZB" 41,
   "SVK" 54,
   "JAM" 115,
   "NIC" 131,
   "TZA" 189,
   "COL" 125,
   "NGA" 214,
   "PRY" 136,
   "GUM" 351,
   "KEN" 180,
   "GIN" 208,
   "HKG" 354,
   "CHE" 94,
   "LIE" nil ;;"Liechtenstein",
   "PRK" 7,
   "DZA" 139,
   "LAO" 12,
   "MUS" 183,
   "NOR" 90,
   "GRL" 349,
   "GAB" 173})

(def ihme->code
  (dissoc (zipmap (vals code->ihme) (keys code->ihme)) ""))

(def code->name
  ;; Generated by code->name*
  {"MTQ" "Martinique"
   "GUY" "Guyana"
   "TGO" "Togo"
   "VCT" "Saint Vincent and the Grenadines"
   "MAF" "Saint Martin (French part)"
   "BFA" "Burkina Faso"
   "ARM" "Armenia"
   "IDN" "Indonesia"
   "MWI" "Malawi"
   "AUT" "Austria"
   "BGD" "Bangladesh"
   "MDV" "Maldives"
   "WSM" "Samoa"
   "MAR" "Morocco"
   "SRB" "Serbia"
   "TKL" "Tokelau"
   "IRN" "Iran, Islamic Republic of"
   "SYR" "Syrian Arab Republic"
   "JOR" "Jordan"
   "MOZ" "Mozambique"
   "UGA" "Uganda"
   "COG" "Congo"
   "SGS" "South Georgia and the South Sandwich Islands"
   "POL" "Poland"
   "OMN" "Oman"
   "MRT" "Mauritania"
   "BMU" "Bermuda"
   "BEL" "Belgium"
   "SYC" "Seychelles"
   "CCK" "Cocos (Keeling) Islands"
   "GBR" "United Kingdom"
   "SPM" "Saint Pierre and Miquelon"
   "DOM" "Dominican Republic"
   "MNG" "Mongolia"
   "CYP" "Cyprus"
   "SVN" "Slovenia"
   "LCA" "Saint Lucia"
   "SLE" "Sierra Leone"
   "YEM" "Yemen"
   "MHL" "Marshall Islands"
   "SWE" "Sweden"
   "ARE" "United Arab Emirates"
   "EGY" "Egypt"
   "ZAF" "South Africa"
   "FIN" "Finland"
   "IRQ" "Iraq"
   "GLP" "Guadeloupe"
   "CZE" "Czech Republic"
   "TKM" "Turkmenistan"
   "TCA" "Turks and Caicos Islands"
   "MCO" "Monaco"
   "BLR" "Belarus"
   "CYM" "Cayman Islands"
   "NIU" "Niue"
   "CPV" "Cape Verde"
   "FRO" "Faroe Islands"
   "GGY" "Guernsey"
   "MAC" "Macao"
   "CHN" "China"
   "LTU" "Lithuania"
   "BVT" "Bouvet Island"
   "TWN" "Taiwan"
   "CRI" "Costa Rica"
   "VNM" "Vietnam"
   "WLF" "Wallis and Futuna"
   "HTI" "Haiti"
   "LKA" "Sri Lanka"
   "ARG" "Argentina"
   "LVA" "Latvia"
   "DJI" "Djibouti"
   "PYF" "French Polynesia"
   "ZWE" "Zimbabwe"
   "NFK" "Norfolk Island"
   "LBY" "Libya"
   "SAU" "Saudi Arabia"
   "VGB" "Virgin Islands, British"
   "GMB" "Gambia"
   "TUV" "Tuvalu"
   "BEN" "Benin"
   "GTM" "Guatemala"
   "ROU" "Romania"
   "ESH" "Western Sahara"
   "KGZ" "Kyrgyzstan"
   "DEU" "Germany"
   "FJI" "Fiji"
   "MKD" "Macedonia"
   "HRV" "Croatia"
   "HUN" "Hungary"
   "SHN" "Saint Helena, Ascension and Tristan da Cunha"
   "SMR" "San Marino"
   "IND" "India"
   "GNQ" "Equatorial Guinea"
   "NPL" "Nepal"
   "PRI" "Puerto Rico"
   "AFG" "Afghanistan"
   "PNG" "Papua New Guinea"
   "ATF" "French Southern Territories"
   "ZMB" "Zambia"
   "REU" "Réunion"
   "PRT" "Portugal"
   "GUF" "French Guiana"
   "UKR" "Ukraine"
   "MSR" "Montserrat"
   "SUR" "Suriname"
   "BGR" "Bulgaria"
   "TUN" "Tunisia"
   "GHA" "Ghana"
   "MDA" "Moldova, Republic of"
   "AGO" "Angola"
   "MLT" "Malta"
   "CAN" "Canada"
   "PAK" "Pakistan"
   "VUT" "Vanuatu"
   "KHM" "Cambodia"
   "ERI" "Eritrea"
   "MNE" "Montenegro"
   "FRA" "France"
   "CMR" "Cameroon"
   "SXM" "Sint Maarten (Dutch part)"
   "SDN" "Sudan"
   "CUB" "Cuba"
   "THA" "Thailand"
   "URY" "Uruguay"
   "COK" "Cook Islands"
   "IOT" "British Indian Ocean Territory"
   "AZE" "Azerbaijan"
   "VAT" "Holy See (Vatican City State)"
   "CUW" "Curaçao"
   "TCD" "Chad"
   "COM" "Comoros"
   "BLM" "Saint Barthélemy"
   "BWA" "Botswana"
   "NRU" "Nauru"
   "BHS" "Bahamas"
   "AND" "Andorra"
   "GIB" "Gibraltar"
   "BRB" "Barbados"
   "TJK" "Tajikistan"
   "BDI" "Burundi"
   "IMN" "Isle of Man"
   "PSE" "Palestinian Territories"
   "EST" "Estonia"
   "BTN" "Bhutan"
   "KIR" "Kiribati"
   "KOR" "Korea, Republic of"
   "SLB" "Solomon Islands"
   "KAZ" "Kazakhstan"
   "ABW" "Aruba"
   "JEY" "Jersey"
   "SWZ" "Swaziland"
   "ITA" "Italy"
   "NAM" "Namibia"
   "PHL" "Philippines"
   "RUS" "Russian Federation"
   "MMR" "Myanmar"
   "VIR" "Virgin Islands, U.S."
   "KNA" "Saint Kitts and Nevis"
   "NLD" "Netherlands"
   "LSO" "Lesotho"
   "HND" "Honduras"
   "MEX" "Mexico"
   "CAF" "Central African Republic"
   "ALA" "Åland Islands"
   "ETH" "Ethiopia"
   "DNK" "Denmark"
   "KWT" "Kuwait"
   "DMA" "Dominica"
   "ECU" "Ecuador"
   "RWA" "Rwanda"
   "SJM" "Svalbard and Jan Mayen"
   "ATG" "Antigua and Barbuda"
   "TLS" "Timor-Leste"
   "NER" "Niger"
   "GRC" "Greece"
   "SOM" "Somalia"
   "TON" "Tonga"
   "GNB" "Guinea-Bissau"
   "GRD" "Grenada"
   "GEO" "Georgia"
   "SLV" "El Salvador"
   "LUX" "Luxembourg"
   "NCL" "New Caledonia"
   "ISL" "Iceland"
   "QAT" "Qatar"
   "BRA" "Brazil"
   "BIH" "Bosnia and Herzegovina"
   "NZL" "New Zealand"
   "JPN" "Japan"
   "PER" "Peru"
   "LBN" "Lebanon"
   "BHR" "Bahrain"
   "ATA" "Antarctica"
   "TUR" "Turkey"
   "VEN" "Venezuela, Bolivarian Republic of"
   "TTO" "Trinidad and Tobago"
   "STP" "Sao Tome and Principe"
   "ESP" "Spain"
   "AIA" "Anguilla"
   "SGP" "Singapore"
   "SEN" "Senegal"
   "HMD" "Heard Island and McDonald Islands"
   "MDG" "Madagascar"
   "ISR" "Israel"
   "BES" "Bonaire, Sint Eustatius and Saba"
   "ASM" "American Samoa"
   "USA" "United States of America"
   "PLW" "Palau"
   "ALB" "Albania"
   "LBR" "Liberia"
   "BOL" "Bolivia, Plurinational State of"
   "SSD" "South Sudan"
   "BRN" "Brunei Darussalam"
   "CHL" "Chile"
   "FSM" "Micronesia, Federated States of"
   "PAN" "Panama"
   "FLK" "Falkland Islands (Malvinas)"
   "COD" "Congo, the Democratic Republic of the"
   "MNP" "Northern Mariana Islands"
   "IRL" "Ireland"
   "CIV" "Côte d'Ivoire"
   "MLI" "Mali"
   "MYS" "Malaysia"
   "MYT" "Mayotte"
   "kosovo" "Kosovo"
   "PCN" "Pitcairn"
   "UMI" "United States Minor Outlying Islands"
   "CXR" "Christmas Island"
   "AUS" "Australia"
   "BLZ" "Belize"
   "UZB" "Uzbekistan"
   "SVK" "Slovakia"
   "JAM" "Jamaica"
   "NIC" "Nicaragua"
   "TZA" "Tanzania, United Republic of"
   "COL" "Colombia"
   "NGA" "Nigeria"
   "PRY" "Paraguay"
   "GUM" "Guam"
   "KEN" "Kenya"
   "GIN" "Guinea"
   "HKG" "Hong Kong"
   "CHE" "Switzerland"
   "LIE" "Liechtenstein"
   "PRK" "Korea, Democratic People's Republic of"
   "DZA" "Algeria"
   "LAO" "Lao People's Democratic Republic"
   "MUS" "Mauritius"
   "NOR" "Norway"
   "GRL" "Greenland"
   "GAB" "Gabon"})

(def name->code
  (zipmap (vals code->name)
          (keys code->name)))
